import { WalletMultiButton } from "@solana/wallet-adapter-react-ui";
import Iconify from "components/iconify";
import "./WalletButton.css"; // Import the CSS

const WalletButton = () => {
  return (
    <WalletMultiButton
      startIcon={<Iconify icon="token-branded:phantom" width={20} height={20} />}
    />
  );
};

export default WalletButton;
